import { ListItem } from '@material-ui/core';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import React, { FunctionComponent } from 'react';
import { NavLink } from 'react-router-dom';

interface Props {
    icon: JSX.Element;
    label: string;
    selected?: boolean;
    href: string;
    onClick?: () => void;
}

const MenuListItem: FunctionComponent<Props> = (
    { icon, label, selected, href, onClick },
) => (
    <div onClick={onClick}>
        <ListItem
            button
            selected={selected}
            component={NavLink}
            to={href}
        >
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText>{label}</ListItemText>
        </ListItem>
    </div>
);

export default MenuListItem;
